// @ts-ignore
import { SUBJECTS_SLUGS } from '@yandex-int/k-common/constants';
import get from 'lodash/get';
import {
    getHints,
    // @ts-ignore
} from 'platform-components/src/components/user/selectors';
import { createSelector } from 'reselect';

import { UMKHintData, UMKSubjectClassHintData } from 'common.components/typings';
import { UMK_DATA } from 'common.components/user/user.constants';
import { getClassIdFromProps, getSubjectFromProps } from 'utils/selectors/selectors';

export const getUMKHintData = createSelector(getHints, (hints: { [UMK_DATA]: UMKHintData }) =>
    get(hints, UMK_DATA, {})
);

export const getSelectedUmk = createSelector(
    [getUMKHintData, getClassIdFromProps, getSubjectFromProps],
    (umkHints: Record<number, UMKSubjectClassHintData>, teamId, subject: SUBJECTS_SLUGS): string | null => {
        const { schoolbooks }: UMKSubjectClassHintData = teamId
            ? get(umkHints, teamId, {} as UMKSubjectClassHintData)
            : ({} as UMKSubjectClassHintData);

        // тайпинг для schoolbooks[subject]
        // @ts-ignore
        return schoolbooks ? schoolbooks[subject] : null;
    }
);
